// Default placeholder images
export const DEFAULT_RACE_IMAGE = 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=800&q=80';
export const DEFAULT_ORGANIZER_LOGO = 'https://via.placeholder.com/96';
export const DEFAULT_POST_IMAGE = 'https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=800&q=80';
